/** https://docs.tsafe.dev/objectentries */
function objectEntries(o) {
    return Object.entries(o);
}

export { objectEntries };
//# sourceMappingURL=objectEntries.mjs.map
